// Mui Components
import { Box } from "@mui/material";

// Layouts
import DashboardLayout from "../../../Layouts/Dashboard";

// Components
import MainButton from "../../../components/@core/button";
import Hero from "../../../components/@core/hero";

// Styles
import { styles } from "./styles";

// Icons
import DashboardIconActive from "../../../assets/icons/nav/icon@dashboard-a.svg";

function Countries() {
  return (
    <DashboardLayout>
      <Box sx={styles.hero}>
        <Box>
          <Hero icon={DashboardIconActive} label="Countries" />
        </Box>
        <Box>
          <MainButton size="large" variant="contained">
            Add New Country
          </MainButton>
        </Box>
      </Box>
    </DashboardLayout>
  );
}

export default Countries;
